import React from "react";

interface ValueCardProps {
  title: string;
  value: string | number;
  description?: string;  // optional descriptive text
  footnote?: string;     // optional smaller footnote
}

export const ValueCard: React.FC<ValueCardProps> = ({ title, value, description, footnote }) => {
  return (
    <div className="rounded-2xl shadow-md p-4 bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700">
      <h3 className="text-sm font-medium text-gray-600 dark:text-gray-400 mb-1">{title}</h3>
      <p className="text-2xl font-bold text-gray-900 dark:text-gray-100">{value}</p>
      {description && <p className="text-sm text-gray-700 dark:text-gray-300 mt-2">{description}</p>}
      {footnote && <p className="text-xs text-gray-500 dark:text-gray-500 mt-1">{footnote}</p>}
    </div>
  );
};

export default ValueCard;
